import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import FilterCDB from "./filterCDB";
import FilterH1 from "./filterH1";
import FilterH23 from "./filterH23";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import * as R from "ramda";
import {mapToObjectDDL} from "../../../../common/mapper";
import {fetchDataAsync} from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import {HttpStatus} from "../../../../common/Constants";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import {connect} from "react-redux";

class CrmCDBFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            activeTab: "CDB",
            activeTabIndex: 0,
            options: {
                provinceOptions: [],
                kabkotOptions: [],
                kecamatanOptions: [],
                kelurahanOptions: [],
                zipCodeOptions: [],
                zipCodeRaw: [],
                genderOptions: [],
                religionOptions: [],
                seriesOptions: [],
                tipeOptions: [],
                variantOptions: [],
                warnaOptions: [],
                leasingOptions: [],
                jobOptions: [],
                partOptions: [],
                statusKPBOptions: [
                    {label: "ALL", value: "ALL"},
                    {label: "KADALUARSA", value: "KADALUARSA"},
                    {label: "DIGUNAKAN", value: "DIGUNAKAN"},
                ],
                operatorOptions: [
                    {label: "<", value: "<"},
                    {label: "<=", value: "<="},
                    {label: ">", value: ">"},
                    {label: ">=", value: ">="},
                    {label: "=", value: "="},
                ],
                jenisPenjualanOptions: [
                    {label: "CASH", value: "CASH"},
                    {label: "CREDIT", value: "CREDIT"},
                ],
                jenisKonsumenOptions: [
                    {label: "Individu", value: "INDIVIDU"},
                    {label: "Perusahaan", value: "PERUSAHAAN"},
                ],
                socMedOptions: [
                    {label: "ALL", value: "ALL"},
                    {label: "ADA", value: "EXIST"},
                    {label: "TIDAK ADA", value: "NOT_EXIST"},
                ],
                levelOptions: [
                    {label: "Gold", value: "GOLD"},
                    {label: "Silver", value: "SILVER"},
                ],
                loyaltyOptions: [
                    {label: "Buyer", value: "BUYER"},
                    {label: "Customer", value: "CUSTOMER"},
                    {label: "Advokat", value: "ADVOCATE"},
                ],
                kategoriDiscOptions: [
                    {label: "DOMINANCE", value: "DOMINANCE"},
                    {label: "INFLUENCE", value: "INFLUENCE"},
                    {label: "STEADINESS", value: "STEADINESS"},
                    {label: "COMPLIANCE", value: "COMPLIANCE"},
                ],
                specialCategoryOptions: [
                    {label: "Pembawa", value: "PEMBAWA"},
                    {label: "Makelar", value: "BROKER"},
                    {label: "Affiliate", value: "AFFILIATE"},
                ]
            },
        }
    }

    componentDidMount = async () => {
        console.log("state", this.props.state);
        this.handleTriggerLoading();
        this.fetchDataProvince();
        this.fetchDataJob();
        this.fetchBizpar();
        this.fetchMasterData();
        if (!R.isNil(this.props.state.filterData.filterCDB?.province)) {
            this.fetchDataKabKot(this.props.state.filterData.filterCDB.province.value);
        }
        if (!R.isNil(this.props.state.filterData.filterCDB?.kabkot)) {
            this.fetchDataKecamatan(this.props.state.filterData.filterCDB.kabkot.value);
        }
        // if (!R.isNil(this.props.state))
        this.handleTriggerLoading();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const prevProvince = prevProps.state?.filterData?.filterCDB?.province?.value;
        const province = this.props.state?.filterData?.filterCDB?.province?.value;
        if (prevProvince !== province) {
            this.setDataOptions("kabkotOptions", []);
            this.setDataOptions("kecamatanOptions", []);
            this.setDataOptions("kelurahanOptions", []);
            this.setDataOptions("zipCodeOptions", []);
            this.setDataOptions("zipCodeRaw", []);

            const tab = this.state.activeTab;
            this.props.onSetState((prevState) => ({
                ...prevState,
                filterData: {
                    ...prevState.filterData,
                    [tab]: {
                        ...prevState.filterData[tab],
                        kabkot: null,
                        kecamatan: null,
                        kelurahan: null,
                        zipCode: null
                    }
                }
            }));

            if (province) {
                this.fetchDataKabKot(province);
            }
        }

        const prevKabKot = prevProps.state?.filterData?.filterCDB?.kabkot?.value;
        const kabKot = this.props.state?.filterData?.filterCDB?.kabkot?.value;
        if (prevKabKot !== kabKot) {
            this.setDataOptions("kecamatanOptions", []);
            this.setDataOptions("kelurahanOptions", []);
            this.setDataOptions("zipCodeOptions", []);
            this.setDataOptions("zipCodeRaw", []);

            const tab = this.state.activeTab;
            this.props.onSetState((prevState) => ({
                ...prevState,
                filterData: {
                    ...prevState.filterData,
                    [tab]: {
                        ...prevState.filterData[tab],
                        kecamatan: null,
                        kelurahan: null,
                        zipCode: null
                    }
                }
            }));

            if (kabKot) {
                this.fetchDataKecamatan(kabKot);
            }
        }

        const prevKecamatan = prevProps.state?.filterData?.filterCDB?.kecamatan?.value;
        const kecamatan = this.props.state?.filterData?.filterCDB?.kecamatan?.value;
        if (prevKecamatan !== kecamatan) {
            this.setDataOptions("kelurahanOptions", []);
            this.setDataOptions("zipCodeOptions", []);
            this.setDataOptions("zipCodeRaw", []);

            const tab = this.state.activeTab;
            this.props.onSetState((prevState) => ({
                ...prevState,
                filterData: {
                    ...prevState.filterData,
                    [tab]: {
                        ...prevState.filterData[tab],
                        kelurahan: null,
                        zipCode: null
                    }
                }
            }));

            if (kecamatan) {
                this.fetchDataKelurahan(kecamatan);
            }
        }

        const prevKelurahan = prevProps.state?.filterData?.filterCDB?.kelurahan?.value;
        const kelurahan = this.props.state?.filterData?.filterCDB?.kelurahan?.value;
        if (prevKelurahan !== kelurahan && !R.isEmpty(this.state.options.zipCodeRaw)) {
            const data = this.state.options.zipCodeRaw.find(item => item.id === kelurahan);
            this.setDataOptions("zipCodeOptions", !R.isEmpty(data) ? [mapToObjectDDL(data?.zipcode, data?.zipcode)] : []);
        }

        const prevListSeries = prevProps.state?.filterData?.filterH1?.listSeries;
        const listSeries = this.props.state?.filterData?.filterH1?.listSeries;
        if (prevListSeries !== listSeries) {
            this.setDataOptions("tipeOptions", []);
            this.setDataOptions("variantOptions", []);
            this.setDataOptions("warnaOptions", []);

            const tab = this.state.activeTab;
            this.props.onSetState((prevState) => ({
                ...prevState,
                filterData: {
                    ...prevState.filterData,
                    [tab]: {
                        ...prevState.filterData[tab],
                        listTipe: null,
                        listVarian: null,
                        listWarna: null,
                    }
                }
            }));

            if (listSeries) {
                let params = {paramFilters: {status: "ACTIVE"}};
                const containsAll = !!(!listSeries || listSeries?.some(item => item.value === "ALL"));
                if (!containsAll) {
                    params = listSeries.map(item => item.value);
                }

                this.fetchDataType(params, containsAll);
            }
        }

        const prevListTipe = prevProps.state?.filterData?.filterH1?.listTipe;
        const listTipe = this.props.state?.filterData?.filterH1?.listTipe;
        if (prevListTipe !== listTipe) {
            this.setDataOptions("variantOptions", []);
            this.setDataOptions("warnaOptions", []);

            const tab = this.state.activeTab;
            this.props.onSetState((prevState) => ({
                ...prevState,
                filterData: {
                    ...prevState.filterData,
                    [tab]: {
                        ...prevState.filterData[tab],
                        listVarian: null,
                        listWarna: null,
                    }
                }
            }));

            if (listTipe) {
                let params = {paramFilters: {status: "ACTIVE"}};
                const containsAll = !!(!listTipe || listTipe?.some(item => item.value === "ALL"));
                if (!containsAll) {
                    params = listTipe.map(item => item.value);
                }

                this.fetchDataVariant(params, containsAll);
            }
        }

        const prevListVariant = prevProps.state?.filterData?.filterH1?.listVarian;
        const listVarian = this.props.state?.filterData?.filterH1?.listVarian;
        if (prevListVariant !== listVarian) {
            this.setDataOptions("warnaOptions", []);

            const tab = this.state.activeTab;
            this.props.onSetState((prevState) => ({
                ...prevState,
                filterData: {
                    ...prevState.filterData,
                    [tab]: {
                        ...prevState.filterData[tab],
                        listWarna: null,
                    }
                }
            }));

            if (listVarian) {
                let params = {paramFilters: {status: "ACTIVE"}};
                const containsAll = !!(!listVarian || listVarian?.some(item => item.value === "ALL"));
                if (!containsAll) {
                    params = listVarian.map(item => item.value);
                }

                this.fetchDataWarna(params, containsAll);
            }
        }
    };

    setDataOptions = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            options: {
                ...prevValue.options,
                [name]: value
            }
        }));
    };

    fetchMasterData = async () => {
        const configs = [
            {
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSeriesByParam,
                key: "seriesOptions",
                mapFn: item => mapToObjectDDL(item.seriesName, item.id),
                menuName: "CDB - Customer Profile"
            },
            {
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterLeasing,
                key: "leasingOptions",
                mapFn: item => mapToObjectDDL(item.leasingName, item.leasingId),
                menuName: "Faktur Jual - Sales Order"
            },
            {
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterPart,
                key: "partOptions",
                mapFn: item => mapToObjectDDL(item.partName, item.kodePart),
                menuName: "Faktur Jual - Sales Order"
            }
        ];

        const responses = await Promise.all(
            configs.map(cfg =>
                fetchDataAsync({
                    asyncFn: cfg.asyncFn,
                    setError: this.props.setError,
                    menuName: cfg.menuName,
                    args: {paramFilters: {status: "ACTIVE"}, limit: null, page: null},
                })
            )
        );

        responses.forEach((response, idx) => {
            const cfg = configs[idx];
            if (response?.data?.status === HttpStatus.SUCCESS) {
                const mappedOptions = response.data.data.map(cfg.mapFn);
                const options = idx === 1 ? mappedOptions : [{label: "ALL", value: "ALL"}, ...mappedOptions];
                this.setDataOptions(cfg.key, options);
            }
        });
    };

    fetchBizpar = async () => {
        const bizparConfigs = [
            {key: "genderOptions", category: "GENDER_TYPE"},
            {key: "religionOptions", category: "RELIGION_TYPE"},
            {key: "hobbyOptions", category: "HOBBY_TYPE"},
            {key: "interestOptions", category: "INTEREST_TYPE"},
            // {key: "jobOptions", category: "JOB_TYPE"},
        ];

        const responses = await Promise.all(
            bizparConfigs.map(config =>
                fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
                    setError: this.props.setError,
                    menuName: "CRM Management CDB",
                    args: {paramFilters: {bizparCategory: config.category}},
                })
            )
        );

        responses.forEach((response, idx) => {
            const config = bizparConfigs[idx];
            if (response?.data?.status === HttpStatus.SUCCESS) {
                const mappedOptions = response.data.data.map(item => mapToObjectDDL(item.value, item.key));
                if (idx === 4) {
                    mappedOptions.unshift({label: "ALL", value: "ALL"});
                }
                this.setDataOptions(config.key, mappedOptions);
            }
        });
    };

    fetchDataJob = async () => {
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").masterServiceMainPage,
            setError: this.props.setError,
            menuName: "CRN - Manajemen CDB",
            args: {},
        })

        if (response.ok && !R.isEmpty(response.data.data)) {
            this.setDataOptions("jobOptions", response.data.data.map(item => mapToObjectDDL(item.namaJasa, item.kodeJasa)));

        }
    };

    fetchDataProvince = async () => {
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllProvince,
            setError: this.props.setError,
            menuName: "CRN - Manajemen CDB",
            args: null,
        })

        if (response.ok && !R.isEmpty(response.data.data)) {
            this.setDataOptions("provinceOptions", response.data.data.map(item => mapToObjectDDL(item.provinceName, item.id)));

        }
    };

    fetchDataKabKot = async (id) => {
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllCity,
            setError: this.props.setError,
            menuName: "CRN - Manajemen CDB",
            args: id,
        })

        if (response.ok && !R.isEmpty(response.data.data)) {
            this.setDataOptions("kabkotOptions", response.data.data.map(item => mapToObjectDDL(item.kabKotName, item.kabKotId)));

        }
    };

    fetchDataKecamatan = async (id) => {
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan,
            setError: this.props.setError,
            menuName: "CRN - Manajemen CDB",
            args: id,
        })

        if (response.ok && !R.isEmpty(response.data.data)) {
            this.setDataOptions("kecamatanOptions", response.data.data.map(item => mapToObjectDDL(item.kecamatanName, item.id)));

        }
    };

    fetchDataKelurahan = async (id) => {
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan,
            setError: this.props.setError,
            menuName: "CRN - Manajemen CDB",
            args: id,
        });

        if (response.ok && !R.isEmpty(response.data.data)) {
            this.setDataOptions("kelurahanOptions", response.data.data.map(item => mapToObjectDDL(item.kelurahanname, item.id)));
            this.setDataOptions("zipCodeRaw", response.data.data);
        }
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    setValue = (tab, name, value) => {
        console.log(tab, name, value);
        this.props.onSetState((prevState) => ({
            ...prevState,
            filterData: {
                ...prevState.filterData,
                [tab]: {
                    ...prevState.filterData[tab],
                    [name]: value,
                }
            }
        }))
    };

    setValueDate = (tab, name, dateName, value) => {
        this.props.onSetState((prevState) => ({
            ...prevState,
            filterData: {
                ...prevState.filterData,
                [tab]: {
                    ...prevState.filterData[tab],
                    [name]: {
                        ...prevState.filterData[tab]?.[name],
                        [dateName]: value,
                    },
                }
            }
        }))
    };

    handleTabSelect = (index) => {
        this.setState({activeTabIndex: index});
        const tabNames = ["filterCDB", "filterH1", "filterH23"];
        this.setState({activeTab: tabNames[index]});
    }

    fetchDataType = async (param = {paramFilters: {status: "ACTIVE"}}, isAll) => {
        let response;
        if (isAll) {
            response = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllType,
                setError: this.props.setError,
                menuName: "CRN - Manajemen CDB",
                args: param,
            })
        } else {
            response = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllTypeByListKodeSeries,
                setError: this.props.setError,
                menuName: "CRN - Manajemen CDB",
                args: param,
            })
        }

        if (response.ok && !R.isEmpty(response.data.data)) {
            this.setDataOptions("tipeOptions", response.data.data.map(item => mapToObjectDDL(item.typeName, item.id)));
        }
    }

    fetchDataVariant = async (param = {paramFilters: {status: "ACTIVE"}}, isAll) => {
        let response;
        if (isAll) {
            response = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
                setError: this.props.setError,
                menuName: "CRN - Manajemen CDB",
                args: param,
            })
        } else {
            response = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllVariantByListKodeType,
                setError: this.props.setError,
                menuName: "CRN - Manajemen CDB",
                args: param,
            })
        }

        if (response.ok && !R.isEmpty(response.data.data)) {
            this.setDataOptions("variantOptions", response.data.data.map(item => mapToObjectDDL(item.namaVariant, item.kodeVariant)));
        }
    }

    fetchDataWarna = async (param = {paramFilters: {status: "ACTIVE"}}, isAll) => {
        let response;
        if (isAll) {
            response = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllWarna,
                setError: this.props.setError,
                menuName: "CRN - Manajemen CDB",
                args: param,
            })
        } else {
            response = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllWarnaByListKodeVariant,
                setError: this.props.setError,
                menuName: "CRN - Manajemen CDB",
                args: param,
            })
        }

        if (response.ok && !R.isEmpty(response.data.data)) {
            this.setDataOptions("warnaOptions", response.data.data.map(item => mapToObjectDDL(item.namaWarnaKomersil, item.id)));
        }
    }

    render() {
        return (
            <>
                <SimpleModal
                    title="Filter Search"
                    visible={this.props.state.filterVisible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            {this.props.tab === "create_prospek" ? (
                                <>
                                    <Tabs selectedIndex={this.state.activeTabIndex} onSelect={this.handleTabSelect}>
                                        <TabList>
                                            <Tab>CDB</Tab>
                                            <Tab>H1</Tab>
                                            <Tab>H23</Tab>
                                        </TabList>
                                        <TabPanel key={"cdb"}>
                                            <FilterCDB
                                                state={this.props.state}
                                                options={this.state.options}
                                                onValueChange={this.setValue}
                                                onSubmit={this.handleSubmitFilter}
                                            />
                                        </TabPanel>
                                        <TabPanel key={"h1"}>
                                            <FilterH1
                                                state={this.props.state}
                                                options={this.state.options}
                                                onValueChange={this.setValue}
                                                onDateChange={this.setValueDate}
                                                onSubmit={this.handleSubmitFilter}
                                            />
                                        </TabPanel>
                                        <TabPanel key={"h23"}>
                                            <FilterH23
                                                state={this.props.state}
                                                options={this.state.options}
                                                onValueChange={this.setValue}
                                                onSubmit={this.handleSubmitFilter}
                                            />
                                        </TabPanel>
                                    </Tabs>
                                </>
                            ) : (
                                <>
                                    <FilterCDB
                                        state={this.props.state}
                                        options={this.state.options}
                                        onValueChange={this.setValue}
                                        onSubmit={this.handleSubmitFilter}
                                    />
                                </>
                            )}

                            <FlexView style={{justifyContent: "right", marginTop: "20px", gap: "20px"}}>
                                <SimpleButton
                                    onClick={this.props.onResetFilter}
                                >Reset</SimpleButton>
                                <SimpleButton
                                    onClick={this.props.onSubmitFilter}
                                >Terapkan</SimpleButton>
                            </FlexView>

                        </ModalContainer>
                    }
                />

                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(CrmCDBFilter);